"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var saveWeatherOption = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(legacy_1.action('saveWeatherOption')(function saveWeatherOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, calendarConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions, calendarConfiguration = state.calendarConfiguration;
                    // update the UserOptions so that changes reflect in current session
                    userOptions.WeatherEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.weatherEnabled, calendarConfiguration.WeatherEnabled);
                    userOptions.WeatherUnit = owa_options_core_1.getFallbackValueIfNull(optionState.weatherUnit, calendarConfiguration.WeatherUnit);
                    calendarConfiguration.WeatherEnabled = userOptions.WeatherEnabled;
                    calendarConfiguration.WeatherUnit = userOptions.WeatherUnit;
                    // save the new calendar configuration at server
                    return [4 /*yield*/, owa_calendar_configuration_1.saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    // save the new calendar configuration at server
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
exports.default = saveWeatherOption;
//# sourceMappingURL=saveWeatherOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/actions/saveWeatherOption.js
// module id = 5248
// module chunks = 2